import React from 'react'
import PropTypes from 'prop-types'
import ExtendableList from 'components/materialUI/ExtendableList'
import withFetchMagentoCategories from 'hocs/extends/withFetchMagentoCategories'

const MagentoCategories = withFetchMagentoCategories()(
  ({
    magentoCategories,
    onClick,
  }) => {
    return (
      <ExtendableList
        treeList={magentoCategories}
        onClick={onClick}
      />
    )
  }
)

MagentoCategories.propTypes = {}
MagentoCategories.defaultProps = {}

export default MagentoCategories



// WEBPACK FOOTER //
// ./src/components/magento/MagentoCategories.js